/**
 * The respsonsibility of this component is to render the menus in the dialog.
 * Pass menusList as props to render the menus with icon, menuName and onClick handler.
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, Divider } from '@mui/material';
import { EditIcon, TrashIcon, StopIcon, SoldOut } from '../../icons/FontAwesomeIcon';
import { Body2 } from '../../themes/typography';

function Menus({
    id = 'menu',
    open = false,
    anchorEl = null,
    onClick = () => { },
    onClose = () => { },
    menus = menusList,
    shouldDisabledMenus = false,
    shouldShowIcons = true,
    shouldShowDividerAtLast = false,
    isLogoutMenu = false
}) {
    return (
        <React.Fragment>
            <Menu
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClick={onClick}
                onClose={onClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                slotProps={slotProp}
            >
                {menus.map((menu, index) => {
                    const isLastItem = index === menus.length - 1;

                    return (
                        <React.Fragment key={index}>
                            {/* Show divider above last item if enabled */}
                            {shouldShowDividerAtLast && isLastItem && <Divider sx={dividerStyles} />}

                            <MenuItem
                                onClick={menu.onClick}
                                sx={{ gap: '0.75rem', minHeight: '32px', paddingTop: '8px', paddingBottom: '8px' }}
                                disabled={shouldDisabledMenus}
                            >
                                {shouldShowIcons && menu.icon}
                                <Body2
                                    color={
                                        isLogoutMenu && index === menus.length - 1
                                            ? 'var(--error-main-color)'
                                            : 'var(--primary-color)'
                                    }
                                >
                                    {menu.menuName}
                                </Body2>
                            </MenuItem>

                            {/* Regular divider between other items */}
                            {!shouldShowDividerAtLast &&
                                index < menus.length - 1 &&
                                <Divider sx={dividerStyles} />}
                        </React.Fragment>
                    );
                })}
            </Menu>
        </React.Fragment>
    );
}

export default memo(Menus);

// Typechecking props
Menus.propTypes = {
    id: PropTypes.string,
    open: PropTypes.bool,
    anchorEl: PropTypes.any,
    onClick: PropTypes.func,
    onClose: PropTypes.func
};

// pre defined menus list
const menusList = [
    {
        id: 'edit-ticket',
        icon: <EditIcon />,
        menuName: 'Edit ticket',
        onClick: () => console.log('Edit ticket')
    },
    {
        id: 'mark-sold-out',
        icon: <SoldOut />,
        menuName: 'Mark as sold out',
        onClick: () => console.log('Mark as sold out')
    },
    {
        id: 'end-sales',
        icon: <StopIcon />,
        menuName: 'End sales',
        onClick: () => console.log('End sales')
    },
    {
        id: 'delete-ticket',
        icon: <TrashIcon />,
        menuName: 'Delete ticket',
        onClick: () => console.log('Delete ticket')
    }
];

const dividerStyles = {
    marginTop: '4px !important',
    marginBottom: '4px !important',
    backgroundColor: 'var(--divider-color)',
    opacity: '0.5',
    margin: '0 8px'
};

const slotProp = {
    paper: {
        sx: {
            borderRadius: '0.75rem'
        }
    }
};